module.exports = __webpack_public_path__ + "img/support-of-ajuntament-de-palma.6b6535cd.jpg";